import { Easing, ReduceMotion } from 'react-native-reanimated';
import { SpringConfig } from 'react-native-reanimated/lib/typescript/animation/springUtils';
import { WithTimingConfig } from 'react-native-reanimated/lib/typescript/animation';

export const DEFAULT_SPRING_CONFIG_INTRO: SpringConfig = {
  damping: 500,
  mass: 3,
  overshootClamping: false,
  reduceMotion: ReduceMotion.System,
  restDisplacementThreshold: 0.01,
  restSpeedThreshold: 2,
  stiffness: 650,
};

export const DEFAULT_SPRING_CONFIG_DISMISS: SpringConfig = {
  damping: 100,
  mass: 2,
  overshootClamping: false,
  reduceMotion: ReduceMotion.System,
  restDisplacementThreshold: 0.01,
  restSpeedThreshold: 2,
  stiffness: 900,
  velocity: 500,
};

export const DEFAULT_EASING_OUT_CONFIG: WithTimingConfig = {
  duration: 200,
  easing: Easing.out(Easing.cubic),
};

export const DEFAULT_EASING_IN_OUT_CONFIG: WithTimingConfig = {
  duration: 200,
  easing: Easing.inOut(Easing.cubic),
};

export const BOTTOM_NAV_BAR_REVEAL_TIMING_CONFIG: WithTimingConfig = {
  duration: 340,
  easing: Easing.bezier(0.32, 0.72, 0, 1),
  reduceMotion: ReduceMotion.System,
};

export const BOTTOM_NAV_BAR_HIDE_TIMING_CONFIG: WithTimingConfig = {
  duration: 500,
  easing: Easing.bezier(0.32, 0.72, 0, 1),
  reduceMotion: ReduceMotion.System,
};
